import type { DiffMap } from '@/shared/tools/diff-mapper'

import React from 'react'
import { isNumber } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '@/shared/components/ui/modal'

type Props = {
	diff: DiffMap[]
	isOpen: boolean
	apply(): void
	close(): void
}

export default function PricingCampaignConfirmationUpdateModal({
	isOpen,
	close,
	diff,
	apply,
}: Props) {
	const { t } = useTranslation()

	return (
		<Modal
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					close()
				}
			}}
		>
			<ModalContent className='max-w-5xl'>
				<ModalHeader>
					<ModalTitle>{t('app.save_settings')}</ModalTitle>
				</ModalHeader>
				<ModalBody className='flex flex-col space-y-5'>
					<p>{t('pc.save.settings.confirmation_text')}</p>
					<ul className='ml-3 list-disc space-y-2'>
						{diff.map(({ action, path }: DiffMap) => (
							<li key={path.join('.')}>
								{`${action}: `}
								{path
									.map((v, index) =>
										isNumber(v)
											? `#${v + 1} ${index !== path?.length - 1 ? '->' : ''}`
											: v
									)
									.join(' ')
									.replaceAll('_', ' ')}
							</li>
						))}
					</ul>
				</ModalBody>
				<ModalFooter className='justify-between'>
					<Button onClick={close}>{t('general_cancel')}</Button>
					<Button
						variant='primary'
						onClick={() => {
							apply()
							close()
						}}
					>
						{t('general_confirm')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}
